import environment from '@/environment';
import { Response } from 'miragejs';
import { paginateList } from './helpers';

const getCapturedTransactions = (server) => {
  /**
   * Notice the use of `function` to declare the handler for the endpoint URL.
   * We want the reference to "this" to point to MirageJS's FunctionRouteHandler context.
   */
  // eslint-disable-next-line func-names,prefer-arrow-callback
  server.get(`${environment.getApiGatewayUrl()}/v1/charges`, function (schema, request) {
    const statusParam = request.queryParams.status;
    // eslint-disable-next-line no-unused-vars
    let statusFilters = [];

    if (Array.isArray(statusParam)) {
      statusFilters = statusParam;
    } else if (statusParam) {
      statusFilters = [statusParam];
    }

    const transactions = schema.transactions.all().filter(tr => (!statusFilters.length) || (statusFilters.indexOf(tr.status) > -1));

    const serializedList = this.serialize(transactions).transactions;

    const displayList = paginateList(
      serializedList,
      parseInt(request.queryParams.page, 10),
      parseInt(request.queryParams.maxPerPage, 10)
    );

    return new Response(
      200,
      {
        'X-Total-Count': serializedList.length,
      },
      displayList,
    );
  });
};

const getDisputes = (server) => {
  /**
   * Notice the use of `function` to declare the handler for the endpoint URL.
   * We want the reference to "this" to point to MirageJS's FunctionRouteHandler context.
   */
  // eslint-disable-next-line func-names,prefer-arrow-callback
  server.get(`${environment.getApiGatewayUrl()}/v1/disputes`, function (schema, request) {
    const disputes = schema.disputes.all();

    const serializedList = this.serialize(disputes).disputes;

    const displayList = paginateList(
      serializedList,
      parseInt(request.queryParams.page, 10),
      parseInt(request.queryParams.maxPerPage, 10)
    );

    return new Response(
      200,
      {
        'X-Total-Count': serializedList.length,
      },
      displayList,
    );
  });
};


export default (server) => {
  getCapturedTransactions(server);
  getDisputes(server);
};
